import { Component, OnInit, Input } from "@angular/core";
import { Router } from "@angular/router";

@Component({
    selector: "app-cliente-no-valido",
    templateUrl: "./cliente-no-valido.component.html",
    styleUrls: ["./cliente-no-valido.component.css"],
    standalone: false
})
export class ClienteNoValidoComponent implements OnInit {
  constructor(public oRouter: Router) {}

  ngOnInit() {}
}
